"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.idToUUID = exports.UUIDTableMap = exports.formattedPriceStringFromPence = exports.longStringFromDate = void 0;
/** Formats a date to string in the format Friday, 9th September 2022 */
const longStringFromDate = (date, options) => {
    const formatter = new Intl.DateTimeFormat('en-GB', {
        // always include the week day name, unless explicitly told not to
        weekday: options?.includeWeekdayName === false ? undefined : 'long',
        day: 'numeric',
        month: 'long',
        year: 'numeric',
        timeZone: options?.timeZone,
    });
    let formattedDate = formatter.format(date);
    let day = date.getDate();
    // JavaScript's Intl.DateTimeFormat can't add ordinal suffixes, so we must add them ourselves
    const daySuffix = (day) => {
        if (day > 3 && day < 21)
            return 'th';
        switch (day % 10) {
            case 1:
                return 'st';
            case 2:
                return 'nd';
            case 3:
                return 'rd';
            default:
                return 'th';
        }
    };
    // Insert ordinal suffix after the first number (i.e not the year number) (caution: untested for locales other than en-GB)
    formattedDate = formattedDate.replace(/\d+/, `${day}${daySuffix(day)}`);
    return formattedDate;
};
exports.longStringFromDate = longStringFromDate;
/** Formats a number in pence to a pretty string. e.g. 100 becomes £1 */
const formattedPriceStringFromPence = (currencyValueInPence, fractionDigits, showInPenceWhereApplicable) => {
    if (showInPenceWhereApplicable && currencyValueInPence < 100 /* £1 */) {
        return `${currencyValueInPence.toLocaleString('en-GB', {
            currency: 'GBP',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        })}p`;
    }
    return `£${(currencyValueInPence / 100).toLocaleString('en-GB', {
        currency: 'GBP',
        minimumFractionDigits: isWholeNumber(currencyValueInPence, 100)
            ? 0
            : (fractionDigits ?? 2), // Defaults to 2 decimal places, e.g. £1.00 instead of £1
        maximumFractionDigits: 2,
    })}`;
};
exports.formattedPriceStringFromPence = formattedPriceStringFromPence;
function isWholeNumber(number, divisor) {
    return number % divisor === 0;
}
exports.UUIDTableMap = {
    ticket_order: 11,
    subscription: 17,
};
/** converts legacy ids to uuids using mapping above */
const idToUUID = (id, table, seq = 0) => {
    if (!id) {
        throw new Error(`No ID when converting 'idToUUID' for ${table}`);
    }
    // convert id into a valid uuid v4
    const tableId = exports.UUIDTableMap[table];
    return `00000000-${seq.toString().padStart(4, '0')}-4000-${tableId.toString().padStart(4, '0')}-${id.toString().padStart(12, '0')}`;
};
exports.idToUUID = idToUUID;
//# sourceMappingURL=formatting.js.map